import r from"./_Symbol.js";var t=r,a=Object.prototype,o=a.hasOwnProperty,e=a.toString,l=t?t.toStringTag:void 0;var v=function(r){var t=o.call(r,l),a=r[l];try{r[l]=void 0;var v=!0}catch(r){}var c=e.call(r);return v&&(t?r[l]=a:delete r[l]),c};export{v as default};
//# sourceMappingURL=_getRawTag.js.map
